import {
  CHECKOUT_ADAPTER_NONE,
  CHECKOUT_ADAPTER_RWD,
  createCheckoutConfigLoader,
  readCheckoutBootstrap,
  selectCheckoutAdapter,
} from './checkout/bootstrap.js'
import { initializeRwdCheckout } from './checkout/adapters/rwd.js'
import { initializeStorefrontCheckout } from './checkout/adapters/storefront.js'

const initializationAttempts = 3
const initializationRetryDelay = 500

;(function initCheckout() {
  const checkoutBootstrap = readCheckoutBootstrap()
  const checkoutAdapter = selectCheckoutAdapter(checkoutBootstrap)
  if (checkoutAdapter === CHECKOUT_ADAPTER_NONE || window.__octolizeDhlCheckoutInitialized) {
    return
  }

  window.__octolizeDhlCheckoutInitialized = true
  const checkoutConfigLoader = createCheckoutConfigLoader({
    fetch: window.fetch?.bind(window),
    url: checkoutBootstrap.configUrl,
  })

  const initializeAdapter = () => {
    if (checkoutAdapter === CHECKOUT_ADAPTER_RWD) {
      return initializeRwdCheckout({ bootstrap: checkoutBootstrap, configLoader: checkoutConfigLoader })
    }

    return initializeStorefrontCheckout({
      bootstrap: checkoutBootstrap,
      configLoader: checkoutConfigLoader,
    })
  }

  const tryInitializeAdapter = async (attempt = 1) => {
    try {
      const adapter = await initializeAdapter()
      if (adapter) return
    } catch (initializationError) {
      if (attempt >= initializationAttempts) {
        console.error(`[DHL checkout] ${checkoutAdapter} initialization failed`, initializationError)
      }
    }

    if (attempt < initializationAttempts) {
      window.setTimeout(() => tryInitializeAdapter(attempt + 1), initializationRetryDelay)
    } else {
      delete window.__octolizeDhlCheckoutInitialized
    }
  }

  tryInitializeAdapter()
})()
